import * as actionTypes from './actionTypes';

export const openErrorDialog = (myParam) => {
    return {type: actionTypes.OPEN_ERROR_DIALOG, payload: myParam}
}

export const closeErrorDialog = (myParam) => {
    return {type: actionTypes.CLOSE_ERROR_DIALOG, payload: myParam}
}